import {userApi} from '@/api/user';

export const ga = {
  event(gac, gaa, gal, gav) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ga.event',
      gac,
      gaa,
      gal,
      gav,
    });
  },
  bindGoogleClientId() {
    return new Promise((resolve) => {
      const {ga} = window;
      if (!ga) {
        userApi.bindGoogleClientId({googleClientId: 0}).then(
          () => resolve(),
          () => resolve()
        );
        return;
      }

      // 获取 clientId
      ga('create', 'UA-PHEMEX-GA', 'auto');
      const timer = setTimeout(async () => {
        await userApi.bindGoogleClientId({googleClientId: 1});
        resolve();
      }, 2000);
      ga(async (tracker) => {
        clearTimeout(timer);
        const clientId = tracker ? tracker.get('clientId') : 2;
        await userApi.bindGoogleClientId({googleClientId: !clientId ? 3 : clientId});
        resolve();
      });
    });
  },
};
